import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { CSSProperties } from 'react';
import { MajorAccountsHdr } from '../Components/MajorAccountsHdr';
import { MajorAccountsFooter } from '../Components/MajorAccountsFooter';


class FAQ {
    key: number
    Question: string;
    Content: any;
}
const letterSpace = '2px';

const multiLineStyle: CSSProperties = {
    textAlign: 'left',
    padding: '10px'
}
const answerStyle: CSSProperties = {
    letterSpacing: 'normal',
    paddingTop: '16px',
    paddingBottom: '16px',
    fontFamily: 'BarlowMedium'
}
const proofEditLinkStyle: CSSProperties = {
    textDecoration: 'underline',
    color: 'blue'
}

const mapImgStyle: CSSProperties = {
    width: '90%'
}

const openLicense = () => { browserHistory.push(Tgcc.Routes.OtherSchools) }
const openShipping = () => { browserHistory.push(Tgcc.Routes.MajorAccountShipping) }

const shipLink: CSSProperties = {
    textDecoration: 'underline',
    color: 'blue',
    cursor: 'pointer'
}


var minOrderStyle = Object.assign({}, multiLineStyle, { fontSize: '16px', letterSpacing: letterSpace })

const itemStyle: CSSProperties = {
    fontSize: '13px',
    padding: '5px',
    margin: '5px 10px',
    letterSpacing: '2px',
    borderBottom: '1px solid rgba(87,144,161,0.2)',
    fontFamily: 'BarlowLight',
    color: '#616060'
}

const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    top: '150px',
    margin: 'auto auto 200px auto',
    width: '43%'
}
const FAQHdr: CSSProperties = {
    textAlign: 'center',
    position: 'relative',
    top: '100px',
    fontFamily: 'BarlowLight',
    color: '#616060'
}
const questionStyle: CSSProperties = {
    fontFamily: 'Lulo',
    fontSize: '15px',
    letterSpacing: 'normal'
}

class _MajorAccountsFAQ extends React.Component<Tgcc.BaseProps, any>{


    FAQS: FAQ[] = [
        {
            key: 1,
            Question: "How do I start an apparel design?",
            Content: <div style={answerStyle}>Use our easy online proof request system or contact us at 800-472-3269 ext 2. One of our account managers will help you get started!</div>
        }, {
            key: 2,
            Question: "Is there a minimum order requirement?",
            Content: <div style={answerStyle}>Yes, we require a minimum of 36 items for all screen-printed and embroidered items.</div>

        }, {
            key: 3,
            Question: "Is artwork free?",
            Content: <div style={answerStyle}><ul>We never charge an artwork fee for:<li>Properly formatted customer provided artwork files</li><li>Basic modifications to an already existing Graphic Cow design</li><li>Simple designs with clear customer provided direction (to be determined by our art staff)</li></ul> </div>
        }, {
            key: 4,
            Question: "When is there a charge for artwork?",
            Content: <div style={answerStyle}>An art fee is charged for custom designs that require a level of time and attention above our normal allowance. This would include custom sketched artwork and complex design concepts. Fees will vary depending on the complexity of the design, but typically range from $75 to $300 per design and will require a minimum order of 50 pieces. Whether an art fee will be required is determined by our art staff when your proof request is reviewed. If applicable your account manager will contact you with pricing and options before your design is started. We never charge artwork without consulting with you first.
            </div>
        }, {
            key: 5,
            Question: "Are there setup or screen charges?",
            Content: <div style={answerStyle}>Screen printing: All setup and screen charges are included in the price of your apparel.
                Embroidery: There is an initial digitizing fee of $50 per unique design. This is a one-time fee and will not be charged on any reorders. We will waive the digitizing fee on all orders of 48 quantity or more.
            </div>
        }, {
            key: 6,
            Question: "How long will it take to receive my digital proof?",
            Content: <div style={answerStyle}>Digital proofs are typically provided within 1-2 business days. If your design is considered custom, the process can take up to 4-5 business days.</div>
        }, {
            key: 7,
            Question: "How long will it take to receive my order?",
            Content: <div style={answerStyle}>Our standard production time is between 5 -7 business days for screen printed apparel and 10 business days for embroidery from the day we receive your design approval and the details of your order are finalized. Please consider additional days for shipping transit times. For more detailed information, please see the Turn Around &#38; Returns section - <span onClick={openShipping} style={shipLink}>Turn Around &#38; Returns</span></div>
        }, {
            key: 8,
            Question: "Are rush options available?",
            Content: <div style={answerStyle}>We understand last minute orders happen. We do offer rush options along with expedited shipping. For more information on turnaround times for rush orders, please see the Turn Around &#38; Returns section <span onClick={openShipping} style={shipLink}>Turn Around &#38; Returns</span>. If you have questions, please contact your account manager directly for availability, or call us at 1-800-472-3269 ext 2.</div>
        }, {
            key: 9,
            Question: "What do I need to know about printing youth sizes and adult sizes in the same order?",
            Content: <div style={answerStyle}>Your print size is determined by the smallest shirt size on your order. The same print dimensions are used for every shirt regardless of shirt size. When mixing youth and adult sizes, we advise against printing on anything smaller than a Youth Medium.  See chart below for maximum print dimensions of each size. Splitting youth and adult print sizes would require minimum quantities for each and would be priced independently. </div>
        }, {
            key: 10,
            Question: "What are your payment terms?",
            Content: <div style={answerStyle}>Credit card information is required for most orders. We will need credit card information before we can finalize your order. We accept purchase orders from established, approved customers. We will also consider net terms upon completion of our credit application. Please contact your account manager for more details.</div>
        }, {
            key: 11,
            Question: "Can we provide our own apparel to print or embroider?",
            Content: <div style={answerStyle}>All blank apparel must be purchased from The Graphic Cow. We do not print on customer provided apparel.
            </div>
        }, {
            key: 12,
            Question: "Can I request a specific pms ink color?",
            Content: <div style={answerStyle}>We do offer PMS ink matching options. All PMS matches are free of charge on orders of 500 quantity or more. For orders less than 500 qty, there is a $40 per color PMS Match fee.</div>
        }, {
            key: 13,
            Question: "What if I receive damaged shirts?",
            Content: <div style={answerStyle}>If misprinted or damaged apparel slip through our quality control department, please contact us immediately. You will receive a full refund on any confirmed damaged or misprinted goods.</div>
        }, {
            key: 14,
            Question: "What if I am short a few shirts?",
            Content: <div style={answerStyle}>We encourage customers to consider including extra shirts on their order. Due to the complex nature of our press setups, we cannot replace shortages that are inside the standard printing margin of error of 3-5%. </div>
        }, {
            key: 15,
            Question: "Will you sell blank or non-printed apparel?",
            Content: <div style={answerStyle}>We would be happy to sell undecorated apparel. Standard retail rates and shipping charges apply.</div>
        }, {
            key: 16,
            Question: "Can I reorder my design?",
            Content: <div style={answerStyle}>We would love to print a reorder for you! Please reach out to your account manager with the web order number and order details. Keep in mind that reorders require a new setup and you are not guaranteed the same price as your original order. Our standard minimum quantities and price breaks will apply. </div>
        }
    ];

    componentDidMount() {
        var tag = document.getElementById('FAQ');
        tag.scrollIntoView(false);
    }

    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    render() {
        return (
            <div>
                <div id="FAQ"></div>
                <MajorAccountsHdr />
                <h2 style={FAQHdr}>FAQ&#39;s</h2>
                <div style={containerStyle} className='questionCont'>
                    {this.FAQS.map((faq: FAQ) => {
                        return (<div key={faq.key} style={itemStyle}>
                            <div style={questionStyle}>{faq.Question}</div>
                            {faq.Content}
                        </div>)
                    })}
                </div>
                <MajorAccountsFooter state={this.props.state} />
            </div>

        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return {
        state: state
    }
};
export var MajorAccountsFAQ = connect(mapStateToProps)(_MajorAccountsFAQ)